import React, { useState, useEffect, useRef } from 'react'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'

import axios from 'axios'
import styles from './package.css';


const Package = props => {
  const [selectedCity, setSelectedCity] = useState(3178)
  const packageRef = useRef()
  const [data, setData] = useState([])
  const [packages, setPackages] = useState([])

  useEffect(() => {
    axios
      .get('https://api.nightexchange.com/web/getCities', {
        params: {
          brand: 5
        }
      })
      .then(function (response) {
        setData(response.data)
        // console.log(response)
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        // always executed
      })
  }, [])

  useEffect(() => {
    console.log('city selected', selectedCity, packageRef.current)
    axios
      .get('https://api.nightexchange.com/web/getPackages', {
        params: {
          city: selectedCity
        }
      })
      .then(function (response) {
        console.log('getPackages', response.data)
        packageRef.current = response.data[1].PackageId
        setPackages(response.data)
        props.setPackage(packageRef.current)
      })
      .catch(function (error) {
        console.log(error)
      })
      .then(function () {
        // always executed
      })
  }, [selectedCity])

  const setSelectedPackage = e => {
    console.log('setSelectedPackage', e)
    packageRef.current = e
    props.setPackage(e)
  }

  function formatPhoneNumber (phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }

  return (
    <>
      <Form.Group className='mb-3' controlId='CitySelection'>
        <Form.Label style={{ fontSize: 13 }}>Confirm your City</Form.Label>
        <br></br>
        <Form.Select
          style={{ maxWidth: '400px', width: '100%' }}
          onChange={e => setSelectedCity(e.target.value)}
          className = 'custom-select'
        >
          {data &&
            data.map((item, index) => (
              <option key={index} value={item.citycode}>
                {item.cityname} - {formatPhoneNumber(item.phonenum)}
              </option>
            ))}
        </Form.Select>
      </Form.Group>
      <Form.Group
        className='mb-3'
        controlId='ChoosePackage'
        style={{ maxWidth: '400px', width: '100%' }}
      >
        <Form.Label style={{ fontSize: 13 }}>Choose your Package</Form.Label>
        {packages.length && (
          <Table borderless hover>
            <tbody>
              <tr>
                <td>
                  <label className="container-unique">
                    <input
                      id='package_1'
                      type='radio'
                      name='packageID'
                      value='1'
                      onChange={() => setSelectedPackage(packages[0].PackageId)}
                    />
                    <b>
                      {' '}
                      {packages[0].Units} minutes for ${packages[0].Amount}
                    </b>
                    <span className="checkmark"></span>  
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="container-unique">
                    <input
                      id='package_2'
                      type='radio'
                      name='packageID'
                      value='2'
                      onChange={() => setSelectedPackage(packages[1].PackageId)}
                      defaultChecked
                    />
                    <b>  
                      {' '}
                      {packages[1].Units} minutes for ${packages[1].Amount}
                    </b>  
                    <span
                      style={{
                        display: 'block',
                        color: 'red',
                        paddingLeft: '20px'
                      }}
                    >
                      This is our most popular package!
                    </span>
                    <span className="checkmark"></span>  
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="container-unique">
                    <input
                      id='package_3'
                      type='radio'
                      name='packageID'
                      value='3'
                      onChange={() => setSelectedPackage(packages[1].PackageId)}
                    />
                    <b>
                      {' '}
                      {packages[2].Units} minutes for ${packages[2].PackageId}
                    </b>
                   
                    <span
                      style={{
                        display: 'block',
                        color: 'red',
                        paddingLeft: '20px'
                      }}
                    >
                      This is our best value package!
                    </span>
                    <span className="checkmark"></span>
                  </label>
                </td>
              </tr>
            </tbody>
          </Table>
        )}
      </Form.Group>
    </>
  )
}

export default Package
